import { createVNode as _createVNode, resolveComponent as _resolveComponent, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, withCtx as _withCtx, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-17c6542d")

_pushScopeId("data-v-17c6542d")
const _hoisted_1 = { class: "bg-ff table-content" }
const _hoisted_2 = { class: "flex alignC top-button-group" }
const _hoisted_3 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8 mar-l-16" }, "出单时间", -1)
const _hoisted_4 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "出单人", -1)
const _hoisted_5 = /*#__PURE__*/_createVNode("span", { class: "c-60 mar-r-8" }, "保险公司", -1)
const _hoisted_6 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "搜索", -1)
const _hoisted_7 = { class: "mar-t-16" }
const _hoisted_8 = { class: "c-red fw-bold" }
const _hoisted_9 = {
  key: 0,
  class: "c-red"
}
const _hoisted_10 = {
  key: 1,
  class: "c-red"
}
const _hoisted_11 = {
  key: 2,
  class: "c-red"
}
const _hoisted_12 = {
  class: "flex flexC button-group",
  style: {"justify-content":"center"}
}
const _hoisted_13 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "详情", -1)
const _hoisted_14 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "修改", -1)
const _hoisted_15 = /*#__PURE__*/_createVNode("span", { class: "c-red" }, "审核", -1)
const _hoisted_16 = { class: "flex flexR mar-t-22" }
const _hoisted_17 = { class: "detail-wrap" }
const _hoisted_18 = /*#__PURE__*/_createVNode("div", { class: "detail-title" }, "车辆信息", -1)
const _hoisted_19 = /*#__PURE__*/_createVNode("div", { class: "detail-title" }, "保险信息", -1)
const _hoisted_20 = /*#__PURE__*/_createVNode("div", { class: "detail-title" }, "险种金额与合计", -1)
const _hoisted_21 = { class: "money" }
const _hoisted_22 = { class: "money" }
const _hoisted_23 = { class: "money" }
const _hoisted_24 = { class: "money" }
const _hoisted_25 = { class: "money" }
const _hoisted_26 = { class: "money" }
const _hoisted_27 = { class: "money" }
const _hoisted_28 = { class: "money" }
const _hoisted_29 = { class: "money" }
const _hoisted_30 = { class: "c-red fw-bold" }
const _hoisted_31 = { class: "money" }
const _hoisted_32 = { class: "money" }
const _hoisted_33 = /*#__PURE__*/_createVNode("div", { class: "detail-title" }, "赠送与备注", -1)
const _hoisted_34 = { class: "money" }
const _hoisted_35 = /*#__PURE__*/_createTextVNode("关 闭")
const _hoisted_36 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "通 过", -1)
const _hoisted_37 = /*#__PURE__*/_createTextVNode("是")
const _hoisted_38 = /*#__PURE__*/_createTextVNode("否")
const _hoisted_39 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_40 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_41 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_42 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_43 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_44 = /*#__PURE__*/_createTextVNode("%")
const _hoisted_45 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_46 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_47 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_48 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_49 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_50 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_51 = /*#__PURE__*/_createTextVNode("元")
const _hoisted_52 = { class: "dialog-footer" }
const _hoisted_53 = /*#__PURE__*/_createVNode("span", { class: "c-ff" }, "保存", -1)
const _hoisted_54 = /*#__PURE__*/_createTextVNode("取 消")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_date_picker = _resolveComponent("el-date-picker")
  const _component_el_option = _resolveComponent("el-option")
  const _component_el_select = _resolveComponent("el-select")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_table_column = _resolveComponent("el-table-column")
  const _component_el_table = _resolveComponent("el-table")
  const _component_el_pagination = _resolveComponent("el-pagination")
  const _component_el_descriptions_item = _resolveComponent("el-descriptions-item")
  const _component_el_descriptions = _resolveComponent("el-descriptions")
  const _component_el_dialog = _resolveComponent("el-dialog")
  const _component_el_input = _resolveComponent("el-input")
  const _component_el_form_item = _resolveComponent("el-form-item")
  const _component_el_col = _resolveComponent("el-col")
  const _component_el_row = _resolveComponent("el-row")
  const _component_el_radio = _resolveComponent("el-radio")
  const _component_el_radio_group = _resolveComponent("el-radio-group")
  const _component_el_form = _resolveComponent("el-form")
  const _directive_loading = _resolveDirective("loading")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _createVNode("div", _hoisted_2, [
      _hoisted_3,
      _createVNode(_component_el_date_picker, {
        modelValue: _ctx.dateRange,
        "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.dateRange = $event)),
        class: "mar-r-16",
        type: "daterange",
        "unlink-panels": "",
        "range-separator": "-",
        "start-placeholder": "开始日期",
        "end-placeholder": "结束日期",
        onChange: _ctx.getTableData
      }, null, 8, ["modelValue", "onChange"]),
      _hoisted_4,
      _createVNode(_component_el_select, {
        modelValue: _ctx.adminId,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.adminId = $event)),
        class: "mar-r-16",
        placeholder: "请选择",
        clearable: "",
        filterable: "",
        style: {"width":"140px"},
        onChange: _ctx.getTableData
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.adminList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.nickname,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _hoisted_5,
      _createVNode(_component_el_select, {
        modelValue: _ctx.bxgs,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.bxgs = $event)),
        class: "mar-r-16",
        placeholder: "请选择",
        clearable: "",
        filterable: "",
        style: {"width":"160px"},
        onChange: _ctx.getTableData
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insuranceList, (item) => {
            return (_openBlock(), _createBlock(_component_el_option, {
              key: item.id,
              label: item.name,
              value: item.id
            }, null, 8, ["label", "value"]))
          }), 128))
        ]),
        _: 1
      }, 8, ["modelValue", "onChange"]),
      _createVNode(_component_el_button, {
        class: "bg-red",
        onClick: _ctx.getTableData
      }, {
        default: _withId(() => [
          _hoisted_6
        ]),
        _: 1
      }, 8, ["onClick"])
    ]),
    _createVNode("div", _hoisted_7, [
      _withDirectives(_createVNode(_component_el_table, {
        data: _ctx.tableData,
        stripe: "",
        style: {"width":"100%"},
        class: "table",
        "header-cell-style": _ctx.headClass
      }, {
        default: _withId(() => [
          _createVNode(_component_el_table_column, {
            label: "车牌号码",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.car_code || scope.row.car?.code), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "品牌车型",
            align: "center",
            "min-width": "140"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.car?.model_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "车主姓名",
            align: "center",
            "min-width": "80"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.tgr), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "出单人",
            align: "center",
            "min-width": "140"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.admin?.nickname), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "保险公司",
            align: "center",
            "min-width": "100"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.bxgs_name), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "出单日期",
            align: "center",
            "min-width": "110"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.oder_date || scope.row.add_time_text), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "交强险信息",
            align: "center",
            "min-width": "160"
          }, {
            default: _withId((scope) => [
              _createVNode("div", null, "到期日：" + _toDisplayString(scope.row.expiration_time || '-'), 1),
              _createVNode("div", null, "金额：" + _toDisplayString(scope.row.jqxje ? '¥' + scope.row.jqxje : '-'), 1),
              _createVNode("div", null, "政策：" + _toDisplayString(scope.row.jqx_rate ? scope.row.jqx_rate + '%' : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "商业险信息",
            align: "center",
            "min-width": "160"
          }, {
            default: _withId((scope) => [
              _createVNode("div", null, "到期日：" + _toDisplayString(scope.row.syx_time || '-'), 1),
              _createVNode("div", null, "金额：" + _toDisplayString(scope.row.syxje ? '¥' + scope.row.syxje : '-'), 1),
              _createVNode("div", null, "政策：" + _toDisplayString(scope.row.sybx ? scope.row.sybx + '%' : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "意外险信息",
            align: "center",
            "min-width": "160"
          }, {
            default: _withId((scope) => [
              _createVNode("div", null, "到期日：" + _toDisplayString(scope.row.ywx_time || '-'), 1),
              _createVNode("div", null, "金额：" + _toDisplayString(scope.row.ywx ? '¥' + scope.row.ywx : '-'), 1),
              _createVNode("div", null, "政策：" + _toDisplayString(scope.row.ywxa ? scope.row.ywxa + '%' : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "保险信息",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createVNode("div", null, " 返点差异：" + _toDisplayString(scope.row.fdcy ? '¥' + Number(scope.row.fdcy).toLocaleString() : '-'), 1),
              _createVNode("div", _hoisted_8, " 总额：" + _toDisplayString(scope.row.total ? '¥' + Number(scope.row.total).toLocaleString() : '-'), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "备注",
            align: "center",
            "min-width": "150"
          }, {
            default: _withId((scope) => [
              _createTextVNode(_toDisplayString(scope.row.remark), 1)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "状态",
            align: "center",
            "min-width": "120"
          }, {
            default: _withId((scope) => [
              (scope.row.status == 0)
                ? (_openBlock(), _createBlock("span", _hoisted_9, "未通过"))
                : _createCommentVNode("", true),
              (scope.row.status == 1)
                ? (_openBlock(), _createBlock("span", _hoisted_10, "已通过，待审核"))
                : _createCommentVNode("", true),
              (scope.row.status == 2)
                ? (_openBlock(), _createBlock("span", _hoisted_11, "已审核"))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }),
          _createVNode(_component_el_table_column, {
            label: "操作",
            align: "center",
            "min-width": "200",
            fixed: "right"
          }, {
            default: _withId((scope) => [
              _createVNode("div", _hoisted_12, [
                _createVNode(_component_el_button, {
                  class: "border-red mar-r-8",
                  onClick: ($event: any) => (_ctx.openDetailDialog(scope.row))
                }, {
                  default: _withId(() => [
                    _hoisted_13
                  ]),
                  _: 2
                }, 1032, ["onClick"]),
                (scope.row.status == 0)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 0,
                      class: "border-red mar-r-8",
                      onClick: ($event: any) => (_ctx.openEditDialog(scope.row))
                    }, {
                      default: _withId(() => [
                        _hoisted_14
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true),
                (scope.row.status == 1)
                  ? (_openBlock(), _createBlock(_component_el_button, {
                      key: 1,
                      class: "border-red mar-r-8",
                      onClick: ($event: any) => (_ctx.handleDeal(scope.row))
                    }, {
                      default: _withId(() => [
                        _hoisted_15
                      ]),
                      _: 2
                    }, 1032, ["onClick"]))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["data", "header-cell-style"]), [
        [_directive_loading, _ctx.loading]
      ])
    ]),
    _createVNode("div", _hoisted_16, [
      _createVNode(_component_el_pagination, {
        onSizeChange: _ctx.handleSizeChange,
        onCurrentChange: _ctx.handleCurrentChange,
        "current-page": _ctx.currentPage,
        "page-sizes": [10, 20, 50, 100],
        "page-size": _ctx.pageSize,
        layout: "total, sizes, prev, pager, next, jumper",
        total: _ctx.total
      }, null, 8, ["onSizeChange", "onCurrentChange", "current-page", "page-size", "total"])
    ]),
    _createVNode(_component_el_dialog, {
      title: "出单详情",
      modelValue: _ctx.detailForm.dialog_show,
      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (_ctx.detailForm.dialog_show = $event)),
      center: "",
      width: 800
    }, {
      footer: _withId(() => [
        _createVNode(_component_el_button, {
          onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.detailForm.dialog_show = false))
        }, {
          default: _withId(() => [
            _hoisted_35
          ]),
          _: 1
        }),
        (_ctx.detailForm.info.status == 0)
          ? (_openBlock(), _createBlock(_component_el_button, {
              key: 0,
              class: "bg-red",
              onClick: _ctx.detailPass
            }, {
              default: _withId(() => [
                _hoisted_36
              ]),
              _: 1
            }, 8, ["onClick"]))
          : _createCommentVNode("", true)
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode("div", _hoisted_17, [
          _hoisted_18,
          _createVNode(_component_el_descriptions, {
            column: 2,
            border: "",
            size: "small",
            class: "desc-narrow-120"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_descriptions_item, { label: "车牌" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.car_code), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "品牌车型" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.car?.model_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "车架号" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.car?.vin), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "联系方式" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.contact_phone), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "是否续保" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.zx == 1 ? '是' : '否'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item)
            ]),
            _: 1
          }),
          _hoisted_19,
          _createVNode(_component_el_descriptions, {
            column: 2,
            border: "",
            size: "small",
            class: "desc-narrow-100"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_descriptions_item, { label: "保险公司" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.bxgs_name), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "出单日期" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.oder_date), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "车主姓名" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.tgr), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "出单人" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.admin?.nickname), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _hoisted_20,
          _createVNode(_component_el_descriptions, {
            column: 3,
            border: "",
            size: "small",
            class: "desc-narrow-120"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_descriptions_item, { label: "交强险到期日" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_21, _toDisplayString(_ctx.detailForm.info.expiration_time), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "交强险金额" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_22, _toDisplayString(_ctx.detailForm.info.jqxje ? '¥' + Number(_ctx.detailForm.info.jqxje).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "交强险政策" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.jqx_rate ? _ctx.detailForm.info.jqx_rate + '%' : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "商业险到期日" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_23, _toDisplayString(_ctx.detailForm.info.syx_time), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "商业险金额" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_24, _toDisplayString(_ctx.detailForm.info.syxje ? '¥' + Number(_ctx.detailForm.info.syxje).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "商业保险政策" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.sybx ? _ctx.detailForm.info.sybx + '%' : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "意外险到期日" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_25, _toDisplayString(_ctx.detailForm.info.ywx_time), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "意外险金额" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_26, _toDisplayString(_ctx.detailForm.info.ywx ? '¥' + Number(_ctx.detailForm.info.ywx).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "意外险政策" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.ywxa ? _ctx.detailForm.info.ywxa + '%' : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "客户佣金" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_27, _toDisplayString(_ctx.detailForm.info.shfbxgs ? '¥' + Number(_ctx.detailForm.info.shfbxgs).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "车船税" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_28, _toDisplayString(_ctx.detailForm.info.cqs ? '¥' + Number(_ctx.detailForm.info.cqs).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item),
              _createVNode(_component_el_descriptions_item, { label: "保险公司佣金" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_29, _toDisplayString(_ctx.detailForm.info.bxgsfje ? '¥' + Number(_ctx.detailForm.info.bxgsfje).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "总保险合计" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_30, _toDisplayString(_ctx.detailForm.info.total ? '¥' + Number(_ctx.detailForm.info.total).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item),
              _createVNode(_component_el_descriptions_item, { label: "返点差异" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_31, _toDisplayString(_ctx.detailForm.info.fdcy ? '¥' + Number(_ctx.detailForm.info.fdcy).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "保险提成" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_32, _toDisplayString(_ctx.detailForm.info.bxtc ? '¥' + Number(_ctx.detailForm.info.bxtc).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item)
            ]),
            _: 1
          }),
          _hoisted_33,
          _createVNode(_component_el_descriptions, {
            column: 1,
            border: "",
            size: "small",
            class: "desc-narrow-165"
          }, {
            default: _withId(() => [
              _createVNode(_component_el_descriptions_item, { label: "赠送项目" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.zsxm || '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "赠送成本" }, {
                default: _withId(() => [
                  _createVNode("span", _hoisted_34, _toDisplayString(_ctx.detailForm.info.zscb ? '¥' + Number(_ctx.detailForm.info.zscb).toLocaleString() : '-'), 1)
                ]),
                _: 1
              }),
              _createVNode(_component_el_descriptions_item, { label: "备注" }, {
                default: _withId(() => [
                  _createTextVNode(_toDisplayString(_ctx.detailForm.info.remark || '-'), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ], 512), [
          [_directive_loading, _ctx.detailForm.loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"]),
    _createVNode(_component_el_dialog, {
      title: "修改保单",
      modelValue: _ctx.editForm.dialog_show,
      "onUpdate:modelValue": _cache[33] || (_cache[33] = ($event: any) => (_ctx.editForm.dialog_show = $event)),
      center: "",
      width: 1200
    }, {
      footer: _withId(() => [
        _createVNode("span", _hoisted_52, [
          _createVNode(_component_el_button, {
            class: "bg-red",
            onClick: _ctx.editSubmit
          }, {
            default: _withId(() => [
              _hoisted_53
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_el_button, {
            onClick: _cache[32] || (_cache[32] = ($event: any) => (_ctx.editForm.dialog_show = false))
          }, {
            default: _withId(() => [
              _hoisted_54
            ]),
            _: 1
          })
        ])
      ]),
      default: _withId(() => [
        _withDirectives(_createVNode(_component_el_form, {
          model: _ctx.editForm,
          "label-width": "120px"
        }, {
          default: _withId(() => [
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "车牌" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.car_code,
                          "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.editForm.car_code = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "品牌" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.brand,
                          "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_ctx.editForm.brand = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "车架号" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.vin,
                          "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_ctx.editForm.vin = $event)),
                          disabled: ""
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "联系方式" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.contact_phone,
                          "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.editForm.contact_phone = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "车主姓名" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.tgr,
                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (_ctx.editForm.tgr = $event))
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "保险公司" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_select, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.bxgs,
                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (_ctx.editForm.bxgs = $event)),
                          placeholder: "请选择",
                          clearable: "",
                          filterable: ""
                        }, {
                          default: _withId(() => [
                            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.insuranceList, (item) => {
                              return (_openBlock(), _createBlock(_component_el_option, {
                                label: item.name,
                                value: String(item.id),
                                key: item.id
                              }, null, 8, ["label", "value"]))
                            }), 128))
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "出单日期" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.oder_date,
                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (_ctx.editForm.oder_date = $event)),
                          placeholder: "请选择出单日期"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "出单员" }, {
                      default: _withId(() => [
                        _createVNode("span", null, _toDisplayString(_ctx.editForm.issuer_name), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "是否续保" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_radio_group, {
                          modelValue: _ctx.editForm.zx,
                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => (_ctx.editForm.zx = $event))
                        }, {
                          default: _withId(() => [
                            _createVNode(_component_el_radio, { label: "1" }, {
                              default: _withId(() => [
                                _hoisted_37
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_el_radio, { label: "0" }, {
                              default: _withId(() => [
                                _hoisted_38
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "交强险到期日" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.expiration_time,
                          "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => (_ctx.editForm.expiration_time = $event)),
                          placeholder: "请选择交强险到期日"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "交强险金额" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.jqxje,
                          "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (_ctx.editForm.jqxje = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_39
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "交强险政策" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.jqx_rate,
                          "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_ctx.editForm.jqx_rate = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_40
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "商业险到期日" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.syx_time,
                          "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_ctx.editForm.syx_time = $event)),
                          placeholder: "请选择商业险到期日"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "商业险金额" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.syxje,
                          "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_ctx.editForm.syxje = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_41
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "商业险政策" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.sybx,
                          "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_ctx.editForm.sybx = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_42
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "意外险到期日" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_date_picker, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.ywx_time,
                          "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_ctx.editForm.ywx_time = $event)),
                          placeholder: "请选择意外险到期日"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "意外险金额" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.ywx,
                          "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_ctx.editForm.ywx = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_43
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "意外险政策" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.ywxa,
                          "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_ctx.editForm.ywxa = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_44
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "客户佣金" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.shfbxgs,
                          "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_ctx.editForm.shfbxgs = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_45
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "车船税" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.cqs,
                          "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_ctx.editForm.cqs = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_46
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "赠送项目" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.zsxm,
                          "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_ctx.editForm.zsxm = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "保险公司佣金" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.bxgsfje,
                          "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_ctx.editForm.bxgsfje = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_47
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "总保险合计" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.total,
                          "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_ctx.editForm.total = $event)),
                          disabled: ""
                        }, {
                          append: _withId(() => [
                            _hoisted_48
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "赠送成本" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.zscb,
                          "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_ctx.editForm.zscb = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_49
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_row, { gutter: 16 }, {
              default: _withId(() => [
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "返点差异" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.fdcy,
                          "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_ctx.editForm.fdcy = $event)),
                          disabled: ""
                        }, {
                          append: _withId(() => [
                            _hoisted_50
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "保险提成" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.bxtc,
                          "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_ctx.editForm.bxtc = $event))
                        }, {
                          append: _withId(() => [
                            _hoisted_51
                          ]),
                          _: 1
                        }, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_col, { span: 8 }, {
                  default: _withId(() => [
                    _createVNode(_component_el_form_item, { label: "备注" }, {
                      default: _withId(() => [
                        _createVNode(_component_el_input, {
                          class: "input-wid",
                          modelValue: _ctx.editForm.remark,
                          "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_ctx.editForm.remark = $event)),
                          type: "textarea"
                        }, null, 8, ["modelValue"])
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 8, ["model"]), [
          [_directive_loading, _ctx.editForm.loading]
        ])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
})